/* R.S.P. product gallery fixes (added 2026-10-19, theme 3.7). Loaded once from blocks/_product-variants.liquid.

   1. Thumbnail strip: the theme's thumbnail slider treats the tiny mouse movement during a click as a drag,
      so clicks are often lost. Give the strip a 10px drag threshold and free scrolling.

   2. Colour jump: when a colour is picked, the theme slides the gallery to the variant image. Variant images
      are flat lays (they also feed the colour swatches and the collection-page cards, which must stay flat).
      If the variant image's alt text ends in ", flat lay" and the product has an image whose alt text is the
      same with ", front" instead (e.g. "Connor ... in Navy, flat lay" -> "Connor ... in Navy, front"),
      jump to that front image instead. Products without that alt-text pattern behave exactly as before.
      If the gallery is already showing an image of the same colour, it stays where it is. */
(function(){
  var THUMB_PARAMS = { threshold: 10, watchSlidesProgress: true, freeMode: { enabled: true, sticky: false, momentum: true } };

  function slideFor(gallery, mediaId){
    return gallery.querySelector('.product-image-lg:not(.swiper-slide-duplicate)[data-id="' + mediaId + '"]');
  }
  function altOf(slide){
    var img = slide && slide.querySelector('img');
    return img ? (img.getAttribute('alt') || '').trim() : '';
  }
  function colourPrefix(alt){
    var i = alt.lastIndexOf(', ');
    return i > 0 ? alt.slice(0, i + 2).toLowerCase() : '';
  }
  function frontFor(gallery, mediaId){
    var alt = altOf(slideFor(gallery, mediaId));
    if(!/, flat lay$/i.test(alt)) return null;
    var prefix = colourPrefix(alt);
    var want = (prefix + 'front');
    var slides = gallery.querySelectorAll('.product-image-lg:not(.swiper-slide-duplicate)[data-id]');
    for(var i = 0; i < slides.length; i++){
      if(altOf(slides[i]).toLowerCase() === want) return { id: slides[i].getAttribute('data-id'), prefix: prefix };
    }
    return null;
  }
  function tuneThumbs(gallery){
    try {
      var main = gallery.prslider;
      var thumbs = main && main.thumbs && main.thumbs.swiper;
      if(!thumbs || thumbs.rspTuned) return;
      thumbs.params.threshold = THUMB_PARAMS.threshold;
      thumbs.params.watchSlidesProgress = THUMB_PARAMS.watchSlidesProgress;
      thumbs.params.freeMode = Object.assign({}, thumbs.params.freeMode || {}, THUMB_PARAMS.freeMode);
      if(thumbs.originalParams) thumbs.originalParams.freeMode = thumbs.params.freeMode;
      thumbs.update();
      thumbs.rspTuned = true;
    } catch(e) {}
  }

  function patch(){
    var C = customElements.get('media-gallery');
    if(!C || C.prototype.rspFrontJump) return;
    var orig = C.prototype.setActiveMedia;
    C.prototype.setActiveMedia = function(mediaId){
      var args = Array.prototype.slice.call(arguments);
      try {
        var front = frontFor(this, mediaId);
        if(front){
          var active = this.querySelector('.product-image__slider .swiper-slide-active');
          var activeAlt = altOf(active).toLowerCase();
          if(active && activeAlt && activeAlt.indexOf(front.prefix) === 0) return; // already on this colour
          args[0] = front.id;
        }
      } catch(e) {}
      return orig.apply(this, args);
    };
    var origInit = C.prototype.init;
    C.prototype.init = function(){
      var r = origInit.apply(this, arguments);
      tuneThumbs(this);
      return r;
    };
    C.prototype.rspFrontJump = true;

    // Galleries already built before this script ran: tune the strip and open on the front image.
    document.querySelectorAll('media-gallery').forEach(function(g){
      tuneThumbs(g);
      try {
        var target = g.dataset.target;
        var front = target && frontFor(g, target);
        if(front && g.prslider) orig.call(g, front.id);
      } catch(e) {}
    });
  }

  if(customElements.get('media-gallery')) patch(); else customElements.whenDefined('media-gallery').then(patch);
})();
